import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import {DomSanitizer, SafeHtml} from '@angular/platform-browser';

@Component({
    selector: 'mbnm-yesno-dialog',
    templateUrl: './yesno-dialog.component.html',
    styleUrls: ['./yesno-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class YesNoDialogComponent implements OnInit {

  constructor(private sanitizer: DomSanitizer) { }

  data:any;

  yesVerified:boolean;

  ngOnInit() {
  }

  public sanitize(html: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }
}
